import React from "react";
import "./about.css";

const About = () => {
  const experienceYears = new Date().getFullYear() - 2021;

  const stats = [
    { number: `${experienceYears}+`, label: "Years Experience" },
    { number: "15+", label: "Projects Completed" },
    { number: "25%", label: "Development Speedup" },
    { number: "22%", label: "Rework Reduced" }
  ];

  const skillGroups = [
    {
      title: "Frontend Core",
      skills: ["React.js", "Next.js", "JavaScript (ES6+)", "TypeScript", "HTML5 / CSS3"]
    },
    {
      title: "State & Query",
      skills: ["Redux Toolkit", "Context API", "TanStack Query", "Axios", "SignalR"]
    },
    {
      title: "UI & Styling",
      skills: ["Tailwind CSS", "Material UI", "Ant Design", "DevExtreme", "Styled Components", "Bootstrap", "SASS"]
    },
    {
      title: "Backend & APIs",
      skills: ["Python", "Django", "Django Rest Framework", "Node.js", "Express.js"]
    },
    {
      title: "Database & Systems",
      skills: ["SQL / PostgreSQL", "MongoDB", "Linux", "Firebase"]
    },
    {
      title: "Ecosystem & Tools",
      skills: ["Git & GitHub", "Jira / Agile", "Webpack", "i18next", "Scalar / Swagger"]
    }
  ];

  return (
    <div className="about-section">
      <div className="about-container">
        <h2 className="section-title">About Me</h2>
        <p className="section-desc">
          A brief insight into my professional values, technical capabilities, and career journey.
        </p>

        <div className="about-content">
          <div className="about-left">
            <h3 className="about-subtitle">My Journey & Philosophy</h3>
            <p className="about-bio">
              I am a Frontend Developer with {experienceYears}+ years of specialized experience in building high-performance
              and highly responsive web applications. Currently, at <b>NTT DATA Business Solutions</b>,
              I design and deploy complex dashboard systems, HR evaluation tools, and multi-tenant financial applications.
            </p>
            <p className="about-bio">
              I closely collaborate with UI/UX designers and backend developers to translate Figma mockups
              into scalable, modular components. I specialize in state management (Redux, TanStack Query, Context API)
              and optimization techniques (memoization, lazy loading, code-splitting) to reduce initial load times.
            </p>

            <div className="about-stats-grid">
              {stats.map((stat, idx) => (
                <div key={idx} className="about-stat-card glass-panel">
                  <span className="about-stat-number">{stat.number}</span>
                  <span className="about-stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="about-right">
            <h3 className="about-subtitle">Technical Competencies</h3>
            <div className="about-skills-container">
              {skillGroups.map((group, idx) => (
                <div key={idx} className="about-skills-group glass-panel">
                  <h4>{group.title}</h4>
                  <div className="about-skills-list">
                    {group.skills.map((skill, sIdx) => (
                      <span key={sIdx} className="skill-pill">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Experience & Education Timeline */}
        <div className="about-timeline-container">
          <h3 className="about-subtitle timeline-title">Experience & Education</h3>
          <div className="timeline">

            <div className="timeline-item left">
              <div className="timeline-dot"></div>
              <div className="timeline-content-box glass-panel">
                <span className="timeline-date">July 2023 - Present</span>
                <h4>Frontend Developer</h4>
                <h5>NTT DATA Business Solutions</h5>
                <p>
                  Designing and developing responsive, scalable web applications using React.js, TypeScript, and ES6+ JS.
                  Collaborating with UI/UX designers to translate designs into accessible components.
                  Improving performance through lazy loading, memoization, and code splitting, reducing initial load times.
                </p>
              </div>
            </div>

            <div className="timeline-item right">
              <div className="timeline-dot"></div>
              <div className="timeline-content-box glass-panel">
                <span className="timeline-date">Sep 2023 - Jun 2026</span>
                <h4>Computer Programming (Associate Degree)</h4>
                <h5>Anadolu University</h5>
                <p>
                  Specialized in web development, database management systems, and programming algorithms. Developed multiple
                  hands-on projects applying system design patterns and software architectural foundations.
                </p>
              </div>
            </div>

            <div className="timeline-item left">
              <div className="timeline-dot"></div>
              <div className="timeline-content-box glass-panel">
                <span className="timeline-date">Sep 2015 - Jun 2019</span>
                <h4>Finance Degree</h4>
                <h5>Bilecik Şeyh Edebali University</h5>
                <p>
                  Graduated with a Bachelor's Degree in Finance, developing strong analytical thinking, problem-solving,
                  and mathematical modeling competencies that now drive complex algorithm design in programming.
                </p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default About;
